import { components } from './components';
import { starters } from './starters';
import { structure } from './structure';

const index = {
  name: 'grommet',
  components,
  starters,
  structure,
};

export default index;
